import { cacheOnce } from '@koob/utils';
import { get } from './';

export const getCurrencies = cacheOnce(() => get('api/v1/currencies'));
